import React, { useEffect, useState,Fragment, useReducer } from 'react'
import { Badge, Button, Col, Container, Form, FormControl, InputGroup, ListGroup, Row, OverlayTrigger, Tooltip} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import buscarReducer, { initialStateDisabled } from './storeBucar/buscar-Reducer'
import { INIT, RESET, SET_DIAS, SET_DISABLED, SET_TIPO_GESTION } from './storeBucar/types'
import {useFormik} from 'formik'
import { restarMeses } from '../../common/Formatos'
import { Auth, LoadingComponent } from 'recupero-comunes'
import AsignacionMasiva from "./asignacion-masiva";
// import { validationSchemas } from '../../common/validation-Schemas-directo'
import { useLocation, useNavigate } from 'react-router-dom'
import { boolean } from 'yup'
import { limpiarCasosBandeja, obtenerCasosBandeja, obtenerTareasAction, obtenerTareasUsuarioAction, obtenerCasosResponsableRegla } from '../../store/actions/encargado-cia-action'
import { validationSchemas } from '../../common/validations-Schemas-Area-gestion'
import { servicesGetCFGRespuestaExt, servicesGetCasosResponsableRegla, servicePostConfirmaAsignacion} from '../../api/encargado-cia-client';

const hoy = () => {
  const fecha = new Date()
  const hoy = fecha.toISOString().split('T')[0]
  return hoy
}

const resetValues={tipofecha:'',estadocaso:'',
    tipogestion:'',tarea:'', todos:false, idcaso:'',patente:'',siniestro:'',
    fechahasta:'',fechadesde:'',situacionsiniestro:'',declaracionpolicial:'', salvatage:'', intanciajudicial:'',
    indlesionados:'', alcoholemia:'' , sinliquidado:'', asignagestion: '', respuestacia: '', motivorpta:''}

const BuscarCasos = ({tipoGestion}) => {  
  const history = useNavigate()
  const [loading, setLoading]=useState(false)
  const [myValues, setMyValues]=useState(resetValues)
  const [noFechas, setNoFechas]=useState(true)

  const [selected, setSelected]=useState('')
  const [dias, setDias]=useState('')
  
  const [isDias, setIsDias]=useState(false)
  
  const [isFechas, setIsfechas]=useState(true)
  const {rutUsuario, rutOrganizacion}=Auth.currentUser()
  const [respuestas, setRespuestas] = useState([]);
  const [motivos, setMotivos] = useState([]);
  const [allMotivos, setAllMotivos] = useState([]);
  const [complementaFiltro, setComplementaFiltro] = useState("");
  const [disabledBtnAsigna, setDisabledBtnAsigna]=useState(true)
  const [casosResponsableRegla, setCasosResponsableRegla] = useState([]);
  
  const [ verDetalle, setVerDetalle ] = React.useState({ show: false, data: {}, totalCasosAsignar: 0, response: {}});
  const [showToast, setShowToast] = useState(false);
  const handleCloseToast = () => {
    setShowToast(false);
    setVerDetalle({ show: false, data: [], totalCasosAsignar:0, response: {}})
  }

  const data_encargado_recupero = useSelector((state) => state.encargado_compania)
  const {
    cfg_form,
    rangofechas,
    tareas,
    estadocaso,
    tipogestion,
    situacionsiniestro,
    declaracionpolicial,
    criteriofecha,
    tareasusuario,
    intanciajudicial,
    indlesionados,
    asignagestion
  } = data_encargado_recupero
  
    const [stateBuscar, dispatchBuscar]=useReducer(buscarReducer, initialStateDisabled)
    const dispatch = useDispatch()
    const { state } = useLocation()
    let querState =state?.queryState && state?.queryState
     const handleRadio=(e)=>{
      setSelected(e.target.id)
      if(e.target.id==='tipogestion'){
       
        dispatchBuscar({type:RESET})
        dispatchBuscar({type:SET_TIPO_GESTION, payload:{disabled:true, name:e.target.id}})

      } else {

        dispatchBuscar({type:RESET})
        dispatchBuscar({type:SET_DISABLED, payload:{disabled:true, name:e.target.id}})
      }
      setMyValues(resetValues)
      setIsfechas(false)
      
      setIsDias(false)
  
    }
    useEffect(() => {
      console.log("buscar-casos.tipoGestion: ", tipoGestion);
      if (tipoGestion) {
        getMotivos(null, tipoGestion);
        getRespuestas();
      }
    }, [tipoGestion])
  
    const getRespuestas = async () => {
      let query = Buffer.from(JSON.stringify({ concepto: 227, tipoGestion: tipoGestion, idBandeja: 286001})).toString('base64');
      const response = await servicesGetCFGRespuestaExt(query);
  
      setRespuestas(response);
    }
  
    const getMotivos = async (idRespuesta, tg) => {
        let query = Buffer.from(JSON.stringify({ concepto: 228, tipoGestion: tg, idBandeja: 286001})).toString('base64');
        const response = await servicesGetCFGRespuestaExt(query);
  
        setAllMotivos(response);
  
        if (idRespuesta) {
          setMotivos(response.filter(m => idRespuesta !== "" && Number(m.clasRpta) === Number(idRespuesta)));
        }
    }
  const handleLimpliar=()=>{
    setIsfechas(true)
    setSelected('')
    dispatchBuscar({type:INIT})
    dispatch(limpiarCasosBandeja())
    setMyValues(resetValues)
    querState=null
    
    setIsDias(false)
    if(rangofechas){
      setMyValues({...resetValues, fechahasta:hoy(), fechadesde:restarMeses(parseInt(rangofechas['valorParametro']))})
    }
  }
  useEffect(()=>{
    dispatchBuscar({type:INIT})

  },[])

  useEffect(()=>{   
    if( querState){
      let resultado={}
      let valores = Object.values(querState); 
      let myKeys = Object.keys(querState); 
      for(let i=0; i< valores.length; i++){
        
        if(valores[i]!=='' && myKeys[i]!=='rutcia' && myKeys[i]!=='rutusr' ){
          if(myKeys[i]==='audienciapendiente'  ){
            setIsDias(valores[i])            
          } else {
            if(valores[i]!==false){
              resultado[myKeys[i]]=valores[i]
            }
            if (myKeys[i]==='respuestacia') {              
              getMotivos(valores[i], querState.tipoGestion);
            }
            if (myKeys[i] ==='complementaFiltro') {              
              setComplementaFiltro(valores[i]);
            }
          }          
        }
      }      
      let valoresR = Object.values(resultado); 
      let myKeysR = Object.keys(resultado); 
      let filter={...resetValues}
      for(let i=0; i< valoresR.length; i++){
        if(Object.entries(resultado).length===1 ){
              setNoFechas(false)
              dispatchBuscar({type:RESET})
              dispatchBuscar({type:SET_DISABLED, payload:{disabled:false, name:myKeysR[i]}})
              setMyValues({...resetValues,[myKeysR[i]]:valoresR[i], fechadesde:''})
        }else{
          
          if(myKeysR[i]==='tipogestion' ||myKeysR[i]==='intanciajudicial' ){
            setNoFechas(false)
            dispatchBuscar({type:INIT})            
            for(let j=0; j< Object.entries(resultado).length; j++){
              filter[myKeysR[j]]=valoresR[j]
            }
            setMyValues(filter)
          
          }else{
          
            setNoFechas(false)
            for(let j=0; j< Object.entries(resultado).length; j++){
              if(myKeysR[j]==='tarea' || myKeysR[j]==='estadocaso'){
                dispatchBuscar({type:RESET})
                dispatchBuscar({type:SET_DISABLED, payload:{disabled:false, name:myKeysR[j]}})
              }
              filter[myKeysR[j]]=valoresR[j]
            }
            setMyValues(filter)
          }
        }      
      }      
      querState['rutcia'] = rutOrganizacion && rutOrganizacion
      querState['rutusr'] =rutUsuario && rutUsuario
      let query1 = Buffer.from(JSON.stringify(querState)).toString('base64')
      dispatch(obtenerCasosBandeja(query1))
     
    }
  setIsfechas(false)
    querState = null
    history('/area-gestion-compania')
  },[state])
  
  useEffect(()=>{
    if(rangofechas && querState!==null && noFechas){
    setMyValues({...myValues, fechahasta:hoy(), fechadesde:restarMeses(rangofechas && parseInt(rangofechas['valorParametro']))})
  }
  },[rangofechas])
  
  const onSubmitByColor = (color) => {
    setLoading(true)
    let todos = document.getElementById('todos') ? document.getElementById('todos').checked : false;
    let query = { rutcia: rutOrganizacion, rutusr: rutUsuario, todos: todos, color: color}
    
    localStorage.setItem('filtrosAreaGestion',JSON.stringify(query));
    query = Buffer.from(JSON.stringify(query)).toString('base64');
    
    dispatch(obtenerCasosBandeja(query)).then(() => {
      setLoading(false)
    })
  }
  const obtenerTareasUsuario = () => {
    let query = Buffer.from(JSON.stringify({ rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 1 })).toString('base64')
    setLoading(true)
    /*dispatch(
      obtenerTareasUsuarioAction(query)
    ).then(() => {*/

      let queryTareas = Buffer.from(
        JSON.stringify({rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 1, 
          todos: document.getElementById('todos')
            ? document.getElementById('todos').checked
            : false
        })
      ).toString('base64')
      dispatch(obtenerTareasAction(queryTareas)).then(() => {
          setLoading(false)
      })
    //})
  }
  const verCasosResponsalbeRegla = async () => {
    const response = await servicesGetCasosResponsableRegla();

    setCasosResponsableRegla(response);
    let total = response.reduce((a, cv) => a + cv.cantidad, 0);
    setVerDetalle({ show: true, data: response, totalCasosAsignar: total })
  }
  const confirmarAsignacion = async () => {
    console.log("casosResponsableRegla: ", casosResponsableRegla);

    let query = Buffer.from(JSON.stringify({idUsuario:rutUsuario, casosResponsableRegla: casosResponsableRegla })).toString('base64')
    setLoading(true)
    const response = await servicePostConfirmaAsignacion(query);
    console.log("confirmarAsignacion.response: ", response);
    
    setLoading(false)
    setShowToast(true);
    
    if (response && response.code == 1) {
      console.log("setVerDetalle: ", "show:false");
      setVerDetalle({ show: true, data: [], totalCasosAsignar:0, response: response})
    } else {
      let total = casosResponsableRegla?.reduce((a, cv) => a + cv.cantidad, 0);
      setVerDetalle({ show: true, data: casosResponsableRegla, totalCasosAsignar: total, response: response})
    }
  }
  const formik = useFormik({
    initialValues: {
      tipogestion: '',      
      todos: false,
      tarea:'',
      estadocaso:'', 
      fechadesde:'',
      fechahasta:'',
      tipofecha: '',
      siniestro: '',
      patente:'',
      idcaso: '',
      declaracionpolicial:'',
      situacionsiniestro:'',
      intanciajudicial:'',
      indlesionados:'', 
      alcoholemia:'',
      sinliquidado:'',
      asignagestion:'',
      respuestacia: '',
      motivorpta:''            
    },
    validationSchema: validationSchemas(isFechas, isDias, selected, myValues.respuestacia, myValues.motivorpta),
    onSubmit: (formData) => {
      setLoading(true)
        const dataForm = {
            ...formData
        }
        let query ={}
        dataForm['rutcia'] = rutOrganizacion && rutOrganizacion
        dataForm['rutusr'] =rutUsuario && rutUsuario  
        dataForm['tipoGestion'] = tipoGestion && tipoGestion  
        dataForm['complementaFiltro'] = complementaFiltro && complementaFiltro  
        for (let key in dataForm) {
          if (dataForm[key] !== null && dataForm[key] !== '') {
            query[key] = dataForm[key]
          }  
        }         
        localStorage.setItem('filtrosAreaGestion',JSON.stringify(query))
        query = Buffer.from(JSON.stringify(query)).toString('base64')
        dispatch(limpiarCasosBandeja()) 
        dispatch(obtenerCasosBandeja(query)).then(() => {
        setLoading(false)        
      })           
    }
})

  return (
    <>
 <style type='text/css'>
        {`
    .btn-limpiar {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-limpiar:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-buscar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-buscar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-asignar {
        background-color: #55B2CE;
        color: #FFFFFF;
        width: 160px;
    }
    .btn-asignar:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    `}
    </style>
      <LoadingComponent show={loading}/>
    <Form onSubmit={
                formik.handleSubmit
            }>
          <Container>
            <Container>
            
              {cfg_form? (
                <div >
                  
                <Row>
                  <Col md='4'>
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejatareas-filtro-tareaspendientes']}
                     <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Recargar Tareas Pendientes </Tooltip>}>
                        <Button type="button" style={{ float: 'right', backgroundColor: 'white', color: 'black', border: 'none', marginBottom:'-7px' }} variant="outline-secondary" size="sm" onClick={() => obtenerTareasUsuario()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                            </svg>
                        </Button>
                      </OverlayTrigger>
                   </Form.Label>{' '}
                   <br />
                   <InputGroup>
                     <InputGroup.Radio aria-label="Radio button for following text input" 
                     name='select' id='tarea' 
                     checked={stateBuscar.tarea.disabled}
                     onChange={e=>handleRadio(e)}/>
                     <Form.Select disabled={!stateBuscar.tarea.disabled}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,tarea:e.target.value, respuestacia:"", motivorpta:""})
                        let tarea = tareas.find(element => element.id == e.target.value);
                        setComplementaFiltro("");     
                        if (tarea && tarea.complementaFiltro) {
                          setComplementaFiltro(tarea.complementaFiltro);     
                        }                                          
                        setDisabledBtnAsigna((tarea && tarea.id != 14));//Iniciar Gestión Recupero DIR
                      }}
                      value={formik.values.tarea=myValues.tarea}
                      name='tarea'
                      error={formik.values.error}
                     >
                     <option value={''}>Seleccione...</option>
                        {tareas &&
                          tareas?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                     </Form.Select>
                  </InputGroup>
                  {formik.errors.tarea ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.tarea}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                 </Col>
                 <Col md='3'>
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejatareas-filtro-estadocaso']}
                   </Form.Label>{' '}
                   <br />
                   <InputGroup>
                     <InputGroup.Radio aria-label="Radio button for following text input" 
                     name='select' id='estadocaso' 
                     checked={stateBuscar.estadocaso.disabled}
                     onChange={e=>handleRadio(e)}/>
                     <Form.Select disabled={!stateBuscar.estadocaso.disabled}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,estadocaso:e.target.value})
                       
                      }}
                      value={formik.values.estadocaso=myValues.estadocaso}
                      name='estadocaso'
                      error={formik.values.error}
                     >
                     <option value={''}>Seleccione...</option>
                        {estadocaso &&
                          estadocaso?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                     </Form.Select>
                 </InputGroup>
                 {formik.errors.estado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.estado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col>
                <Col md='2' >
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '14px' }}
                   >
                     {
                       cfg_form[
                         'bandejatareas-filtro-tipogestion'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Select disabled={!stateBuscar.tipogestion.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,tipogestion:e.target.value})
                        
                      }}
                      value={formik.values.tipogestion=myValues.tipogestion}
                      name='tipogestion'
                      error={formik.values.error}
                   >
                   <option value={''}>Seleccione...</option>
                        {tipogestion &&
                          tipogestion?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                 </Col>
                 <Col md='3' >
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '14px' }}
                   >
                     {
                       cfg_form[
                         'bandejatareas-filtro-asignagestion'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Select disabled={!stateBuscar.asignagestion.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,asignagestion:e.target.value})
                        
                      }}
                      value={formik.values.asignagestion=myValues.asignagestion}
                      name='asignagestion'
                      error={formik.values.error}
                   >
                   <option value={''}>Seleccione...</option>
                        {asignagestion &&
                          asignagestion?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                 </Col>                
               </Row>       
              {complementaFiltro ? (
                <Row>
                <Col md='4' > 
                    <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                      {cfg_form['bandejatareas-filtro-respuestacia']}
                    </Form.Label>{' '}
                    <br />
                    <Form.Select  disabled={!stateBuscar.respuestacia.disabled}
                        onChange={(e)=>{
                          formik.handleChange(e)
                          setMyValues({...myValues, respuestacia:e.target.value, motivorpta:""})
                          let motivos = allMotivos.filter(m => e.target.value !== "" && Number(m.clasRpta) === Number(e.target.value))
                          setMotivos(motivos);
                        }}
                        value={formik.values.respuestacia=myValues.respuestacia}
                        name='respuestacia'
                        error={formik.values.error} 
                    >
                    <option value={''}>Seleccione...</option>
                          {respuestas &&
                          respuestas?.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.nombre}
                              </option>
                            ))}
                    </Form.Select>
                    {formik.errors.respuestacia ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.respuestacia}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                  <Col md='4' > 
                    <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                      {cfg_form['bandejatareas-filtro-motivorpta']}
                    </Form.Label>{' '}
                    <br />
                    <Form.Select  disabled={!stateBuscar.motivorpta.disabled}
                        onChange={(e)=>{
                          formik.handleChange(e)
                          setMyValues({...myValues,motivorpta:e.target.value})
                        
                        }}
                        value={formik.values.motivorpta=myValues.motivorpta}
                        name='motivorpta'
                        error={formik.values.error} 
                    >
                    <option value={''}>Seleccione...</option>
                      {motivos &&
                        motivos?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                      ))}
                    </Form.Select>
                    {formik.errors.motivorpta ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.motivorpta}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                </Row>
              ) : null }
               <Row>
                  <Col md='3'>
                    <Form.Label
                      className='mb-2 mt-4'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form[
                          'bandejatareas-filtro-situacionsiniestro'
                        ]
                      }
                    </Form.Label>{' '}
                    <br />
                    <Form.Select disabled={!stateBuscar.situacionsiniestro.disabled}
                        onChange={(e)=>{
                          formik.handleChange(e)
                          setMyValues({...myValues,situacionsiniestro:e.target.value})
                          
                        }}
                        value={formik.values.situacionsiniestro=myValues.situacionsiniestro}
                        name='situacionsiniestro'
                        error={formik.values.error}
                    >
                    <option value={''}>Seleccione...</option>
                          {situacionsiniestro &&
                            situacionsiniestro?.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.nombre}
                              </option>
                            ))}
                    </Form.Select>
                  </Col>
                  <Col  md='3'>
                    <Form.Label
                      className='mb-2 mt-4'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form[
                          'bandejatareas-filtro-declaracionpolicial'
                        ]
                      }
                    </Form.Label>{' '}
                    <br />
                    <Form.Select disabled={!stateBuscar.declaracionpolicial.disabled}
                        onChange={(e)=>{
                          formik.handleChange(e)
                          setMyValues({...myValues,declaracionpolicial:e.target.value})                          
                        }}
                        value={formik.values.declaracionpolicial=myValues.declaracionpolicial}
                        name='declaracionpolicial'
                        error={formik.values.error}
                    >
                    <option value={''}>Seleccione...</option>
                          {declaracionpolicial &&
                            declaracionpolicial?.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.nombre}
                              </option>
                            ))}
                    </Form.Select>
                  </Col>
                  <Col md='3'>
                      <Form.Check 
                      type='checkbox'
                      id='salvatage'
                      name='salvatage'
                      checked={Boolean(myValues.salvatage)}                    
                      label={cfg_form['bandejatareas-filtro-salvatajevisado']}
                      style={{marginTop:'60px'}}
                      onChange={e=>{                        
                        formik.handleChange(e)                      
                        setMyValues({...myValues, salvatage:(e.target.checked)})
                      }}
                      value={formik.values.salvatage=myValues.salvatage}
                    />
                  </Col>
                  <Col md='2'>
                    <Form.Check 
                      type='checkbox'
                      id='todos'
                      name='todos'
                      checked={Boolean(myValues.todos)}                   
                      label={cfg_form['bandejatareas-filtro-todoscasos']}
                      style={{marginTop:'60px'}}
                      onChange={e=>{                      
                        formik.handleChange(e)                      
                        setMyValues({...myValues, todos:(e.target.checked)})
                      }}
                      value={formik.values.todos=myValues.todos}
                    />
                  </Col>                  
                </Row>
                <Row>
                  <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form[
                            'bandejatareas-filtro-instanciajudicial'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Select disabled={!stateBuscar.intanciajudicial.disabled}
                          onChange={(e)=>{
                          formik.handleChange(e)
                          setMyValues({...myValues,intanciajudicial:e.target.value})
                          
                        }}
                        value={formik.values.intanciajudicial=myValues.intanciajudicial}
                        name='intanciajudicial'
                        error={formik.values.error}
                      >
                      <option value={''}>Seleccione...</option>
                          {intanciajudicial &&
                            intanciajudicial?.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.nombre}
                              </option>
                            ))}
                      </Form.Select>
                    </Col>
                    <Col md='3'>
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                        {cfg_form['bandejatareas-filtro-lesionados']}
                      </Form.Label>{' '}
                      <br />
                      <Form.Select disabled={!stateBuscar.indlesionados.disabled}
                          onChange={(e)=>{
                          formik.handleChange(e)
                          setMyValues({...myValues,indlesionados:e.target.value})
                          
                        }}
                        value={formik.values.indlesionados=myValues.indlesionados}
                        name='indlesionados'
                        error={formik.values.error}
                      >
                      <option value={''}>Seleccione...</option>
                          {indlesionados &&
                            indlesionados?.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.nombre}
                              </option>
                            ))}
                      </Form.Select>
                    </Col>
                    <Col md='3'>
                      <Form.Check 
                      type='checkbox'
                      id='alcoholemia'
                      name='alcoholemia'
                      checked={Boolean(myValues.alcoholemia)}                      
                      label={cfg_form['bandejatareas-filtrochk-alcoholemia']}
                      style={{marginTop:'60px'}}
                      onChange={e=>{                        
                        formik.handleChange(e)                      
                        setMyValues({...myValues, alcoholemia:(e.target.checked)})
                      }}
                      value={formik.values.alcoholemia=myValues.alcoholemia}
                      />
                    </Col>
                    <Col md='3'>
                      <Form.Check 
                      type='checkbox'
                      id='sinliquidado'
                      name='sinliquidado'
                      checked={Boolean(myValues.sinliquidado)}                    
                      label={cfg_form['bandejatareas-filtrochk-sinliquidado']}
                      style={{marginTop:'60px'}}
                      onChange={e=>{                        
                        formik.handleChange(e)                      
                        setMyValues({...myValues, sinliquidado:(e.target.checked)})
                      }}
                      value={formik.values.sinliquidado=myValues.sinliquidado}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md='9'>
                  <Row>
                    <Col >
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form['bandejatareas-filtro-fechadesde']}
                      </Form.Label>{' '}
                      <br />                    
                        <Form.Control type='date'disabled={!stateBuscar.fechadesde.disabled}
                        name='fechadesde'
                        value={formik.values.fechadesde=myValues.fechadesde}
                        onChange={(e)=>{
                          formik.handleChange(e)
                          setMyValues({...myValues,fechadesde:e.target.value})                          
                        }
                        }
                        ></Form.Control>
                    </Col>
                    <Col>
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                        {cfg_form['bandejatareas-filtro-fechahasta']}
                      </Form.Label>{' '}
                      <br />
                      <Form.Control type='date'  disabled={!stateBuscar.fechahasta.disabled}
                          name='fechahasta'
                          value={formik.values.fechahasta=myValues.fechahasta}
                          onChange={(e)=>{
                            formik.handleChange(e)
                            setMyValues({...myValues,fechahasta:e.target.value})                            
                          }
                          }
                      ></Form.Control>
                    </Col>
                    <Col  >
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form['bandejatareas-filtro-criteriofecha']}
                      </Form.Label>{' '}
                      <br />
                      <Form.Select  disabled={!stateBuscar.tipofecha.disabled}
                          onChange={(e)=>{
                            formik.handleChange(e)
                            setMyValues({...myValues,tipofecha:e.target.value})                          
                          }}
                          value={formik.values.tipofecha=myValues.tipofecha}
                          name='tipofecha'
                          error={formik.values.error} 
                      >
                      <option value={''}>Seleccione...</option>
                            {criteriofecha &&
                            criteriofecha?.map((c) => (
                                <option key={c.id} value={c.id}>
                                  {c.nombre}
                                </option>
                              ))}
                      </Form.Select>
                      {formik.errors.tipofecha ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.tipofecha}
                        </Form.Text>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row> 
                  <Row>
                    <Col >
                        <Form.Label
                          className='mb-2 mt-4'
                          style={{ fontWeight: 'bold', fontSize: '14px' }}
                        >
                          {
                            cfg_form[
                              'bandejatareas-grilla-siniestro'
                            ]
                          }
                        </Form.Label>{' '}
                        <br />
                        <InputGroup>
                          <InputGroup.Radio aria-label="Radio button for following text input" name='select' id='siniestro' onChange={e=>handleRadio(e)} checked={stateBuscar.siniestro.disabled}/>
                          <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.siniestro.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)                          
                            
                              setMyValues({...myValues,siniestro:e.target.value})
                            }}
                            value={formik.values.siniestro=myValues.siniestro}
                            name='siniestro'
                            error={formik.values.error}
                          />
                      </InputGroup>
                      {formik.errors.siniestro ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.siniestro}
                      </Form.Text>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col>
                        <Form.Label
                          className='mb-2 mt-4'
                          style={{ fontWeight: 'bold', fontSize: '14px' }}
                        >
                          {
                            cfg_form[
                              'bandejatareas-filtro-patente'
                            ]
                          }
                        </Form.Label>{' '}
                        <br />
                        <InputGroup>
                          <InputGroup.Radio aria-label="Radio button for following text input" name='select'
                              id='patente' checked={stateBuscar.patente.disabled}
                              onChange={e=>handleRadio(e)} />
                          <FormControl aria-label="Text input with radio button"  disabled={!stateBuscar.patente.disabled}
                              onChange={(e)=>{
                                formik.handleChange(e)
                                setMyValues({...myValues,patente:e.target.value})
                                
                              }}
                              value={formik.values.patente=myValues.patente}
                              name='patente'
                              error={formik.values.error}
                          />
                        </InputGroup>
                        {formik.errors.patente ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.patente}
                        </Form.Text>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col  >
                        <Form.Label
                          className='mb-2 mt-4'
                          style={{ fontWeight: 'bold', fontSize: '14px' }}
                        >
                          {
                            cfg_form[
                              'bandejatareas-filtro-idcaso'
                            ]
                          }
                        </Form.Label>{' '}
                        <br />
                        <InputGroup>
                          <InputGroup.Radio aria-label="Radio button for following text input"
                          name='select' id='idcaso' 
                          checked={stateBuscar.idcaso.disabled}
                          onChange={e=>handleRadio(e)}/>
                          <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.idcaso.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)
                              
                              setMyValues({...myValues, idcaso: e.target.value})
                            }}
                            value={formik.values.idcaso=myValues.idcaso}
                            name='idcaso'
                            error={formik.values.error}
                        
                          />
                      </InputGroup>
                      {formik.errors.idcaso ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.idcaso}
                      </Form.Text>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row> 
               </Col>
               <Col md='3' className='align-self-center'>
                    <ListGroup>
                      <ListGroup.Item
                        action
                        className='text-center'
                        onClick={() => {
                          obtenerTareasUsuario()
                        }}
                        type='button'
                      >
                        <Row>
                          <Col>
                            <span className='fw-bolder me-2'>
                              {cfg_form['bandejatareas-semaforo-titulo']}
                            </span>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              className='bi bi-arrow-clockwise'
                              viewBox='0 0 16 16'
                            >
                              <path
                                fillRule='evenodd'
                                d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'
                              />
                              <path d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z' />
                            </svg>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <ListGroup.Item
                        action
                        variant='danger'
                        className='text-center'
                        onClick={() => onSubmitByColor('rojo')}
                        type='button'
                      >
                        <Row>
                          <Col>{tareasusuario && tareasusuario[0] && tareasusuario[0].nivel1}</Col>
                          <Col>
                            <Badge bg='danger'>
                              {tareasusuario && tareasusuario[0] && tareasusuario[0].rojo}
                            </Badge>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <ListGroup.Item
                        action
                        variant='warning'
                        className='text-center'
                        onClick={() => onSubmitByColor('amarillo')}
                        type='button'
                      >
                        <Row>
                          <Col>{tareasusuario && tareasusuario[0] && tareasusuario[0].nivel2}</Col>
                          <Col>
                            <Badge bg='warning'>
                              {tareasusuario && tareasusuario[0] && tareasusuario[0].amarillo}
                            </Badge>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <ListGroup.Item
                        action
                        variant='success'
                        className='text-center'
                        onClick={() => onSubmitByColor('verde')}
                        type='button'
                      >
                        <Row>
                          <Col>{tareasusuario && tareasusuario[0] && tareasusuario[0].nivel3}</Col>
                          <Col>
                            <Badge bg='success'>
                              {tareasusuario && tareasusuario[0] && tareasusuario[0].verde}
                            </Badge>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <ListGroup.Item className='text-center'>
                        <Row>
                          <Col>Total</Col>
                          <Col>
                            <Badge>
                              {tareasusuario && tareasusuario[0] && tareasusuario[0].total}
                            </Badge>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                    </ListGroup>
                  </Col>
               </Row>
                         
               <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
               <div className='d-grid gap-2 d-md-flex justify-content-md-end'>
               
                  <Button className='me-md-3' variant='asignar' disabled={disabledBtnAsigna} type='button' onClick={verCasosResponsalbeRegla}>
                      {cfg_form['bandejatareas-boton-asigna']}
                  </Button>
                  <Button className='me-md-2' variant='limpiar' type='button' onClick={handleLimpliar}>
                    {cfg_form['bandejatareas-boton-limpiar']}
                  </Button>
                  <Button variant='buscar' type='onSubmit'>
                    {cfg_form['bandejatareas-boton-buscar']}
                  </Button>
                </div>
               
                </div>
              ) : null}
            </Container>      
          </Container>
          <AsignacionMasiva show={verDetalle.show} data={verDetalle.data} totalCasosAsignar={verDetalle.totalCasosAsignar} response={verDetalle.response} showToast={showToast} handleCloseToast={handleCloseToast}
            onHide={() => setVerDetalle({ show: false, data: {}, totalCasosAsignar:0 })} confirmarAsignacion={() => confirmarAsignacion()} />
     </Form>
    
    </>
  )
}

export default BuscarCasos
